export default __webpack_public_path__ + "static/media/coursebg.c02d1c75.jpg";